import React from 'react';
import MenuButtons from '../../components/MenuButtons/MenuButtons';
import './Menu.scss';
import ProfilePic from '../../assets/images/profile__avatar.png';


const Menu = () => {
    return (
        <div className="menu">
            <div className="menu__welcome">
                <p className="menu__welcome-title">Welcome </p>
                <p className="menu__welcome-name">{localStorage.getItem('name')}!</p>
            </div>
            
                <div className="menu__image-container">
                    <img src={ProfilePic} className="menu__image" alt="profile"></img>
                </div>
                <MenuButtons />
        </div>
    );
};

export default Menu;